<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="header-bg">
      <div class="content-nav-bar" ref="contentNavBar">
        <van-nav-bar title="选择策略">
          <template #left>
            <van-icon name="cross" size="18" @click="close" />
          </template>
        </van-nav-bar>
      </div>
      <ul class="content">
        <template v-for="(item, index) in createArr">
          <li
            :key="index"
            v-if="
              (item.title === '创建动态组合' && compareVersions($route.query.version,9.68)) ||
              item.title === '创建多因子策略' ||
              item.title === '创建量化策略'
            "
            @click="clickIndex = index"
            :class="clickIndex === index ? 'checked-style' : ''"
          >
            <img
              :src="item.img"
              alt=""
              class="left-ico"
              :class="{ 'left-ico-animation': clickIndex === index }"
            />

            <div class="right">
              <p class="title">
                <span class="t-left">{{ item.title }} <i v-if="index !== 0">支持回测</i></span>
                <img
                  src="@/assets/image/xz.png"
                  alt=""
                  class="radio-ico"
                  v-if="clickIndex === index"
                />
                <img src="@/assets/image/qx.png" alt="" class="radio-ico" v-else />
              </p>

              <p class="explain">
                {{ item.explain }}
              </p>
            </div>
          </li>
        </template>
      </ul>

      <div class="btn-padding" v-show="!idShow">
        <van-button type="info" class="create-btn" @click="handleClickCreateBtn"
          >创建策略</van-button
        >
      </div>
      <div class="btn-padding" v-show="idShow">
        <van-button type="info" class="create-btn" @click="handleClickCreateBtnTow"
          >创建策略</van-button
        >
      </div>
    </div>
    <!-- vip弹窗 -->
    <vipInfo :show="vipShow"></vipInfo>

    <!-- 分类选择弹框 -->
    <van-popup v-model="yzType" round position="bottom" :style="{ minHeight: '20%' }">
      <div class="yzTypeList">
        <p class="name">选择因子类型</p>

        <van-radio-group v-model="yzRadio">
          <van-cell-group>
            <div v-for="(item, index) in yzTypeList" :key="item.id">
              <van-cell
                :title="item.name"
                clickable
                @click="handleClickRadio(item.id)"
                :class="yzRadio === index ? 'yztypeChecked' : ''"
                v-if="item.state"
              >
                <template #right-icon>
                  <van-radio :name="item.id" />
                </template>
              </van-cell>
            </div>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import { mapMutations } from 'vuex';
import vipInfo from '@/components/diaLog/vipInfo.vue';
import { getFactorListIsVip, getFactorByIndexCode } from '@/api/create.js';
import { getFactorHq } from '@/api/index.js';
import { Base64 } from 'js-base64';
import { compareVersions } from '@/utils/format.js';

export default {
  name: 'Create',
  mixins: [mixin],
  data() {
    return {
      clickIndex: 0,
      createArr: [
        {
          img: require('@/assets/image/dtzh.png'),
          title: '创建动态组合',
          explain:
            '动态组合 ，实时更新 ，因子更全面 ，支持最新的因子 ，支持查看最新一个交易日信号池 ，支持跟踪最新信号池最近24小时预警信息。'
        },
        {
          img: require('@/assets/image/dyz.png'),
          title: '创建多因子策略',
          explain:
            '支持历史回测，支持动态选股，实时更新，支持策略评价，支持智能参数历史走势回测，支持信号历史明细导出。'
        },
        {
          img: require('@/assets/image/lhcl.png'),
          title: '创建量化策略',
          explain:
            '仅支持量化调仓 ，支持策略评价 ，支持智能参数历史走势回测 ，支持自定义参数历史走势回测，支持成交记录历史明细导出 ，支持走势持续跟踪查看 ，支持盘中策略信号更新，支持一键跟单。'
        }
      ],
      // VIP标志
      isVip: false,
      vipCode:false,
      vipShow: false,
      yzType: false,
      yzTypeList: [
        {
          id: 0,
          name: 'A股因子',
          state: true
        },
        {
          id: 1,
          name: 'ETF因子',
          state: compareVersions(this.$route.query.version , 9.69) ? true : false
        }
      ],
      yzRadio: '',
      // 接受APP客户端传来的factorId
      factorId: '',
      // 客户端传过来的就走直接跳转逻辑
      idShow: false,
      // 传递的原始数组
      listJson: '',
      // 是否可回测
      ishc: true
    };
  },
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    },
    '$store.state.vipCode': {
      handler(newValue) {
        this.vipCode = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  components: { vipInfo },
  filters: {},
  created() {
    this.resetState(); //重置部分vuex
    if (window.DzhAppJs) {
      let obj = {
        navBarHidden: 1,
        titleHidden: 1
      };

      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setTitleStyle', obj, '');
    }
  },
  mounted() {

    this.$store.commit('setBtnDisabled', false);
    var navHeight = this.$refs.contentNavBar.offsetHeight;
    this.$store.commit('setContentNavBar', navHeight);

    if (compareVersions(this.$route.query.version , 9.68)) {
      this.clickIndex = 0;
    } else {
      this.clickIndex = 1;
    }

    // 增加条件 如果存在shopinfo 就默认选中2
    if (this.$route.query.shopinfo) {
      this.clickIndex = 2;
    }


    // 获取APP客户端传来的信息
    // 1. 参数factorId 因子代码
    // 2. 参数yzType A-A股因子，ETF-ETF因子
    // 执行方法 通过因子ID 查询因子本身以及VIP因子
    this.factorId = this.$route.query.factorId;
    // 如果是因子 非 BI YI 的数据
    if (this.factorId && this.factorId !== '') {
      // 判断因子前两位是否是 BI 或者 YI
      if (this.factorId.substring(0, 2) == 'BI' || this.factorId.substring(0, 2) == 'YI') {
        // 转换 indexCode 转 fid
        this.getFactorByIndexCodeFunc(this.factorId);
      } else {
        this.getFactorDetails(this.factorId);
      }
    }
  },
  methods: {
    compareVersions,
    ...mapMutations(['resetState']),
    handleClickCreateBtn: function () {
      this.yzType = true;
    },
    close: function () {
      location.href = 'dzh_browser_url&goto=0&screen=263';
    },
    handleClickRadio: function (i) {
      this.yzRadio = i;

      let source = '';
      if (this.clickIndex === 0) {
        source = 'dtzh';
      } else if (this.clickIndex === 1) {
        source = 'dyzcl';
      } else if (this.clickIndex === 2) {
        source = 'lhcl';
      }




      // 判断是否是VIP
      if (
        this.vipCode == false &&
        (source == 'dyzcl' || source == 'lhcl') && compareVersions(this.$route.query.version , 9.92)

      ){
        let appJson = {
          DialogType: "pro",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (
        this.isVip == false &&
        (source == 'dyzcl' || source == 'lhcl') && compareVersions( this.$route.query.version , 9.71)

      ) {
        // 如果不是VIP用户,弹出VIP提示
        //  this.vipShow = true;
        // 调用客户端js 弹窗
        // 创建多因子策略/创建量化回测 的JSON
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0706',
          sourcecode: '3509',
          mediaID: '0706',
          yzType: i === 0 ? 'A' : 'ETF'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        // 初始化因子组合
        this.$store.commit('setCheckedYzType', 'jj');
        this.$store.commit('resetCheckedYzList');
        this.$store.commit('resetGroupYzList');
        this.$router.push({
          path: '/checkedYz',
          name: 'CheckedYz',
          query: {
            source: source, //用来标注是从动态组合还是多因子还是量化过去的
            type: 'add',
            token: this.$route.query.token || '',
            themeStyleVs: this.$route.query.themeStyleVs || 0,
            version: this.$route.query.version || '',
            yzType: i === 0 ? 'A' : 'ETF'
          }
        });
      }
    },

    //  因子转换
    getFactorByIndexCodeFunc: function (index) {
      getFactorByIndexCode({ code: index })
        .then((result) => {
          if (result.err == 200) {
            this.getFactorDetails(result.data.ID);
          }
        })
        .catch((err) => {});
    },
    // 接收客户端传来的ID , 查询因子详情下一步插入到因子池中
    getFactorDetails: function (id) {
      // 没有接受到ID 走以前逻辑
      if (!id || id == '') {
        // 更改状态
        this.idShow = false;
      } else {
        this.idShow = true;
        // 定制参数
        let resDetailInfo = {};
        let factorInfo = {};
        Promise.all([this.getFactorHqFun(id), this.getFactorListIsVipFun(id)])
          .then((result) => {
            // 合并数据
            let d = this.mergeJSONArrays(result[0], result[1]);
            d.yzType = 0;
            d.Info = d.ID;
            // this.listJson = d;
            // 设置listJson为json数据
            let dataArr = [];
            dataArr[0] = d;
            let jsonData = JSON.stringify(dataArr);
            let decodedString = Base64.encode(jsonData);
            // + 替换为 *，/ 替换为 -，= 替换为 .，
            let replacedString = decodedString
              .replace(/\+/g, '*')
              .replace(/\//g, '-')
              .replace(/\=/g, '.');
            this.listJson = replacedString;
            // 判断是否是可回测
            if (result[0].BacktestType == 1 || result[0].BacktestType == 2) {
              // 可回测
              this.ishc = true;
            } else {
              // 不可回测
              this.ishc = false;
            }
          })
          .catch((err) => {
            console.log('🚀 ~ err:', err);
          });
      }
    },

    // 获取行情信息
    getFactorHqFun: function (id) {
      return new Promise((resolve, reject) => {
        let obj = {
          type: 'cl',
          groupID: id,
          field: 'FactorName,RiZhangFu,XinHaoShuLiang,XiFenZhongLei,LongTouGu,Desc,backtestType'
        };
        getFactorHq(obj)
          .then((resDetail) => {
            if (resDetail.err == 200) {
              resolve(resDetail.data[0]);
            } else {
              reject({});
            }
          })
          .catch((err) => {
            reject({});
          });
      });
    },
    // 获取VIP行情
    getFactorListIsVipFun: function (id) {
      return new Promise((resolve, reject) => {
        let params = {
          factors: id
        };
        // 查询因子详情
        getFactorListIsVip(params)
          .then((result) => {
            if (result.err == 200) {
              resolve(result.data[0]);
            } else {
              reject({});
            }
          })
          .catch((err) => {
            reject({});
          });
      });
    },
    //合并两个具有相同 ID 的 JSON 数组
    mergeJSONArrays: function (obj1, obj2) {
      const mergedObject = {};
      const uniqueKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

      for (let key of uniqueKeys) {
        if (obj1.hasOwnProperty(key) && !obj2.hasOwnProperty(key)) {
          mergedObject[key] = obj1[key];
        } else if (!obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
          mergedObject[key] = obj2[key];
        } else {
          mergedObject[key] = Array.isArray(obj1[key])
            ? obj1[key]
                .concat(obj2[key])
                .filter((item, index, self) => self.indexOf(item) === index)
            : obj1[key];
        }
      }

      return mergedObject;
    },
    // 直接跳转到客户端,并且拼接参数
    handleClickCreateBtnTow: function () {
      let source = '';
      if (this.clickIndex === 0) {
        source = 'dtzh';
      } else if (this.clickIndex === 1) {
        source = 'dyzcl';
      } else if (this.clickIndex === 2) {
        source = 'lhcl';
      }


      // 判断是否是VIP
      if (
        this.vipCode == false &&
        (source == 'dyzcl' || source == 'lhcl') && compareVersions(this.$route.query.version , 9.92)

      ){
        let appJson = {
          DialogType: "pro",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (
        this.isVip == false &&
        (source == 'dyzcl' || source == 'lhcl') && compareVersions(this.$route.query.version , 9.71)

      ) {
        // 如果不是VIP用户,弹出VIP提示
        //  this.vipShow = true;
        // 调用客户端js 弹窗
        // 创建多因子策略/创建量化回测 的JSON
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0706',
          sourcecode: '3509',
          mediaID: '0706',
          yzType: this.$route.query.yzType || ''
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        this.$router.push({
          path: '/checkedYz',
          name: 'CheckedYz',
          query: {
            source: source, //用来标注是从动态组合还是多因子还是量化过去的
            type: 'add',
            token: this.$route.query.token || '',
            themeStyleVs: this.$route.query.themeStyleVs || 0,
            version: this.$route.query.version || '',
            yzType: this.$route.query.yzType || '',
            dtzhHcCheckedYzList: this.ishc || source == 'dtzh' ? this.listJson : '',
            factorId: this.factorId
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.checked-style {
  border: 1px solid rgba(40, 109, 247, 1) !important;
}
.index-info {
  .content {
    padding: 10px 16px 0;
    li {
      padding: 23px 16px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      border: 1px solid #fff;
      -webkit-animation: scale-up-center 0.2s cubic-bezier(0.7, 0.8, 0.9, 1) both;
      animation: scale-up-center 0.2s cubic-bezier(0.7, 0.8, 0.9, 1) both;
      @-webkit-keyframes scale-up-center {
        0% {
          -webkit-transform: scale(0.8);
          transform: scale(0.8);
        }
        100% {
          -webkit-transform: scale(1);
          transform: scale(1);
        }
      }
      @keyframes scale-up-center {
        0% {
          -webkit-transform: scale(0.8);
          transform: scale(0.8);
        }
        100% {
          -webkit-transform: scale(1);
          transform: scale(1);
        }
      }

      .left-ico-animation {
        -webkit-animation: flip-vertical-right 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
        animation: flip-vertical-right 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
        @-webkit-keyframes flip-vertical-right {
          0% {
            -webkit-transform: rotateY(0);
            transform: rotateY(0);
          }
          100% {
            -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
          }
        }
        @keyframes flip-vertical-right {
          0% {
            -webkit-transform: rotateY(0);
            transform: rotateY(0);
          }
          100% {
            -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
          }
        }
      }

      .left-ico {
        width: 48px;
        height: 48px;
        background: #286df7;
        border-radius: 8px;
        flex-shrink: 0;
        margin-right: 7px;
      }
      .right {
        .title {
          font-weight: 600;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: space-between;

          .t-left {
            display: flex;
            align-items: center;
          }
          i {
            font-weight: 400;
            font-size: 12px;
            color: #3b85fe;
            border: 0.5px solid #3b85fe;
            border-radius: 4px;
            padding: 0 4px;
            margin-left: 7px;
          }
          .radio-ico {
            width: 15px;
            height: 15px;
          }
        }
        .explain {
          font-weight: 400;
          font-size: 12px;
          color: #6b7687;
          margin-top: 10px;
        }
      }
    }
  }
  .btn-padding {
    padding: 0 32px;
    position: fixed;
    bottom: 34px;
    width: 100%;
    .create-btn {
      background: #286df7;
      border-radius: 50px;
      font-weight: 600;
      font-size: 16px;
      color: #fff;
      width: 100%;
    }
  }
}

.yzTypeList {
  padding: 16px 16px 40px;
  .name {
    color: rgba(0, 0, 0, 0.9);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
  }
  ::v-deep {
    .van-cell {
      padding: 0;
      border-radius: 8px;
      background: #f5f5f5;
      border: none;
      border: 1px solid #f5f5f5;
      padding: 16px;
      margin-top: 12px;
      &:after {
        display: none;
      }
    }
    .yztypeChecked {
      border: 1px solid #286df7;
      background: #fff;
    }

    [class*='van-hairline']::after {
      display: none;
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .content {
    li {
      border: 1px solid rgba(0, 0, 0, 0);
      background: #1d202d;
    }
    .t-left {
      color: #e4e9fe;
    }
  }

  ::v-deep {
    .van-popup {
      background: #0b0f14;
      .name {
        color: #e4e9fe;
      }
    }
    .van-cell-group {
      background: #0b0f14;
    }
    .van-cell {
      background: #17181b;
      border: 1px solid #17181b;
      .van-cell__title {
        span {
          color: #aab9d1;
        }
      }
      .van-radio__icon--round .van-icon {
        border: 1px solid #6b7687;
      }
    }

    .van-radio__icon--checked .van-icon {
      border: 1px solid #286df7 !important;
    }
  }

  .yztypeChecked {
    border: 1px solid #286df7 !important;
    background: #0c0f13 !important;
  }
}
</style>
